import { Typography } from "@mui/material";
import type { InvestorCommunicationInfo } from "../../api/types/investorCommunicationsTypes";
import NewsItemImage from "./NewsItemImage";
import NewsItemLinkWrapper from "./NewsItemLinkWrapper";
import NewsItemMeta from "./NewsItemMeta";

interface Props {
  item: InvestorCommunicationInfo;
  to: string;
}

const NewsHeroCard = ({ item, to }: Props) => (
  <NewsItemLinkWrapper to={to} spacing={1.5}>
    <NewsItemImage item={item} sx={{ width: "100%", aspectRatio: "3 / 2", mb: 1.5 }} />
    <NewsItemMeta publishedAt={item.publishedAt} categories={item.categories} status={item.status} />
    <Typography variant="h4" className="news-item-title">
      {item.title}
    </Typography>
    {item.description && (
      <Typography variant="caption" color="textSecondary">
        {item.description}
      </Typography>
    )}
  </NewsItemLinkWrapper>
);

export default NewsHeroCard;
